import { useEffect } from 'react';

import { useIsOnAir } from '@/scenarios/legacy-player/components/feature-player/ui/live/live-on-air-control/hooks/use-is-on-air';
import { usePlayingState } from '@/scenarios/legacy-player/hooks/usePlayingState';
import { useSeekToAir } from '@/scenarios/legacy-player/hooks/useSeekToAir';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

export function useKeepOnAir() {
    const seekToAir = useSeekToAir();
    const isOnAir = useIsOnAir();
    const { playingState } = usePlayingState();

    useEffect(() => {
        if (!isOnAir && playingState === PlayingState.play) {
            seekToAir();
        }
    }, [isOnAir, playingState, seekToAir]);
}
